var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinAgainGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 3.66667C11.8793 3.66667 3.66602 11.88 3.66602 22C3.66602 32.12 11.8793 40.3333 21.9993 40.3333C32.1193 40.3333 40.3327 32.12 40.3327 22C40.3327 11.88 32.1193 3.66667 21.9993 3.66667ZM12.0993 20.5883C12.411 18.4067 13.3827 16.445 14.9043 14.905C18.571 11.2567 24.346 11.055 28.2693 14.245V12.5033C28.2693 11.7517 28.8927 11.1283 29.6443 11.1283C30.396 11.1283 31.0193 11.7517 31.0193 12.5033V17.3983C31.0193 18.15 30.396 18.7733 29.6443 18.7733H24.7493C23.9977 18.7733 23.3743 18.15 23.3743 17.3983C23.3743 16.6467 23.9977 16.0233 24.7493 16.0233H26.1243C23.2827 14.0433 19.3593 14.3183 16.8293 16.8483C15.7293 17.9483 15.0327 19.3783 14.7943 20.9733C14.7027 21.6517 14.116 22.1467 13.4377 22.1467C13.3643 22.1467 13.3093 22.1467 13.236 22.1283C12.521 22.0367 11.9893 21.34 12.0993 20.5883ZM29.0943 29.095C27.1327 31.0567 24.566 32.0283 21.9993 32.0283C19.7627 32.0283 17.5443 31.24 15.711 29.755V31.4783C15.711 32.23 15.0877 32.8533 14.336 32.8533C13.5843 32.8533 12.961 32.23 12.961 31.4783V26.5833C12.961 25.8317 13.5843 25.2083 14.336 25.2083H19.231C19.9827 25.2083 20.606 25.8317 20.606 26.5833C20.606 27.335 19.9827 27.9583 19.231 27.9583H17.856C20.6977 29.9383 24.621 29.6633 27.151 27.1333C28.251 26.0333 28.9477 24.6033 29.186 23.0083C29.296 22.2567 29.9743 21.725 30.7443 21.835C31.496 21.945 32.0093 22.6417 31.9177 23.3933C31.5877 25.6117 30.616 27.5733 29.0943 29.095Z",
    fill: "url(#paint0_linear_1018_4580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1018_4580",
    x1: 3.66602,
    y1: 22,
    x2: 40.3327,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinAgainGold);
export default __webpack_public_path__ + "static/media/spin-again-gold.cf3a595ef9bfb583274d55176915cff5.svg";
export { ForwardRef as ReactComponent };